import { Link } from "react-router-dom"
import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import navImg from '../assets/images/Region F_Logo_Color_Final.svg'
import apiHelper from '../helpers/apiHelper';


export default function Navbar() {

    const location = useLocation();
    const { pathname } = location;
    const splitLocation = pathname.split("/");

    // State for dropdowns
    const [documentsDropdownOpen, setDocumentsDropdownOpen] = useState(false);
    const [meetingsDropdownOpen, setMeetingsDropdownOpen] = useState(false);
    const [documentSections, setDocumentSections] = useState([]);
    const [meetingSections, setMeetingSections] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fetch sections data
    useEffect(() => {
        const loadSections = async () => {
            try {
                setLoading(true);
                const api = new apiHelper();
                const [docSections, meetSections] = await Promise.all([
                    api.GetDocumentSections(),
                    api.GetMeetingSections()
                ]);
                setDocumentSections(docSections || []);
                setMeetingSections(meetSections || []);
            } catch (error) {
                console.error('Error loading sections:', error);
            } finally {
                setLoading(false);
            }
        };
        
        loadSections();
    }, []);

    // Helper function to get page data from section
    const getPageData = (section) => {
        try {
            return JSON.parse(section.pageData);
        } catch (error) {
            console.error('Error parsing pageData:', error);
            return { title: 'Error', content: 'Unable to load content' };
        }
    };

    // Handle dropdown hover
    const handleDocumentsMouseEnter = () => {
        setDocumentsDropdownOpen(true);
        setMeetingsDropdownOpen(false); // Close other dropdown
    };

    const handleMeetingsMouseEnter = () => {
        setMeetingsDropdownOpen(true);
        setDocumentsDropdownOpen(false); // Close other dropdown
    };

    const handleDropdownMouseLeave = () => {
        setDocumentsDropdownOpen(false);
        setMeetingsDropdownOpen(false);
    };

    // Close dropdowns when clicking outside
    const closeDropdowns = () => {
        setDocumentsDropdownOpen(false);
        setMeetingsDropdownOpen(false);
    };

    // Add click outside handler
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.dropdown')) {
                closeDropdowns();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div>
            <nav className="navbar navbar-expand-lg" style={{ backgroundColor: '#e7d2b7'}}>
                <div className="container py-3">
                    <a className="navbar-brand my-2 pe-5">
                        <img src={navImg} style={{ height: "90px" }} draggable='false' alt="Region F Water" className="me-3" />
                    </a>
                    <button className="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse text-uppercase justify-content-end" id="navbarCollapse">
                        <ul className="navbar-nav fw-bold" style={{ fontSize: "20px" }}>
                            <li className="nav-item mx-1">
                                <Link className="nav-link" id={(splitLocation[1] === "" ? "active" : "notActive")} to="/" >Home</Link>
                            </li>
                            <li className="nav-item mx-1">
                                <Link className="nav-link" id={(splitLocation[1] === "Planning" ? "active" : "")} to="/Planning">Planning Group</Link>
                            </li>
                            
                            {/* Documents Dropdown */}
                            <li 
                                className="nav-item dropdown mx-1"
                                onMouseEnter={handleDocumentsMouseEnter}
                                onMouseLeave={handleDropdownMouseLeave}
                            >
                                <Link 
                                    className="nav-link dropdown-toggle" 
                                    id={(splitLocation[1] === "Documents" ? "active" : "")} 
                                    to="/Documents?section=0"
                                    style={{ cursor: 'pointer' }}
                                    reloadDocument
                                >
                                    Documents
                                </Link>
                                {documentsDropdownOpen && (
                                    <div className="dropdown-menu show" style={{ 
                                        backgroundColor: '#e7d2b7', 
                                        border: '2px solid #db9e4d',
                                        borderRadius: '8px',
                                        boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                                    }}>
                                        {loading ? (
                                            <div className="dropdown-item text-center py-3">
                                                <div className="spinner-border spinner-border-sm me-2" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                                Loading...
                                            </div>
                                        ) : documentSections.length > 1 ? (
                                            documentSections.filter(s => s.section !== 0).sort((a, b) => a.section - b.section).map((section, index) => {
                                                const pageData = getPageData(section);
                                                return (
                                                    <Link
                                                        key={section.id}
                                                        className="dropdown-item"
                                                        to={`/Documents?section=${section.section}`}
                                                        onClick={closeDropdowns}
                                                        style={{
                                                            color: '#8b6914',
                                                            fontWeight: '500',
                                                            padding: '0.75rem 1.5rem',
                                                            borderBottom: index < documentSections.filter(s => s.section !== 0).length - 1 ? '1px solid #c8923f' : 'none'
                                                        }}
                                                    >
                                                        {pageData.title}
                                                        {section.isDraft && (
                                                            <span className="badge bg-warning text-dark ms-2">Draft</span>
                                                        )}
                                                    </Link>
                                                );
                                            })
                                        ) : (
                                            <div className="dropdown-item text-muted py-3">No sections available</div>
                                        )}
                                    </div>
                                )}
                            </li>

                            {/* Meetings Dropdown */}
                            <li 
                                className="nav-item dropdown mx-1"
                                onMouseEnter={handleMeetingsMouseEnter}
                                onMouseLeave={handleDropdownMouseLeave}
                            >
                                <Link 
                                    className="nav-link dropdown-toggle" 
                                    id={(splitLocation[1] === "Meetings" ? "active" : "")} 
                                    to="/Meetings?section=0"
                                    style={{ cursor: 'pointer' }}
                                    reloadDocument
                                >
                                    Meetings
                                </Link>
                                {meetingsDropdownOpen && (
                                    <div className="dropdown-menu show" style={{ 
                                        backgroundColor: '#e7d2b7', 
                                        border: '2px solid #db9e4d',
                                        borderRadius: '8px',
                                        boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                                    }}>
                                        {loading ? (
                                            <div className="dropdown-item text-center py-3">
                                                <div className="spinner-border spinner-border-sm me-2" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                                Loading...
                                            </div>
                                        ) : meetingSections.length > 1 ? (
                                            meetingSections.filter(s => s.section !== 0).sort((a, b) => a.section - b.section).map((section, index) => {
                                                const pageData = getPageData(section);
                                                return (
                                                    <Link
                                                        key={section.id}
                                                        className="dropdown-item"
                                                        to={`/Meetings?section=${section.section}`}
                                                        onClick={closeDropdowns}
                                                        style={{
                                                            color: '#8b6914',
                                                            fontWeight: '500',
                                                            padding: '0.75rem 1.5rem',
                                                            borderBottom: index < meetingSections.filter(s => s.section !== 0).length - 1 ? '1px solid #c8923f' : 'none'
                                                        }}
                                                    >
                                                        {pageData.title}
                                                        {section.isDraft && (
                                                            <span className="badge bg-warning text-dark ms-2">Draft</span>
                                                        )}
                                                    </Link>
                                                );
                                            })
                                        ) : (
                                            <div className="dropdown-item text-muted py-3">No sections available</div>
                                        )}
                                    </div>
                                )}
                            </li>

                            <li className="nav-item mx-1">
                                <Link className="nav-link" id={(splitLocation[1] === "Contact" ? "active" : "")} to="/Contact">Contacts</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
            <nav className="navbar navbar-expand-lg py-0 shadow-sm" style={{ backgroundColor: '#db9e4d', height:'10px' }}>
            </nav >
        </div >
    )
}